import React from 'react';
import {
  CompleteInspectionContextProvider
} from '../CompleteInspectionContext';
import CompleteInspectionPages from '../CompleteInspectionPages';

const CompleteInspectionPage = () => {
  return (
    <CompleteInspectionContextProvider>
      <CompleteInspectionPages/>
    </CompleteInspectionContextProvider>
  );
};

export default CompleteInspectionPage;
